import React, { useContext, useState } from "react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import Select from "../../shared/Select";
import SpecialistSearch from "../../shared/SpecialistSearch";

const SpecialistSearchFormFields = ({
  state,
  task,
  values,
  setFieldValue,
  ...props
}) => {
  const [selectedSpecialist, setSelectedSpecialist] = useState(props.selectedSpecialist);
  const [specialistDisabled, setSpecialistDisabled] = useState(true);
  const [specialistGroupDisabled, setSpecialistGroupDisabled] = useState(true);
  const [selectedSpecialistGroup, setSelectedSpecialistGroup] = useState(props.selectedSpecialistGroup);
  const [selectedSpecialistPractice, setSelectedSpecialistPractice] = useState(props.selectedSpecialistPractice);
  const [searchedSpecialistPractices, setSearchedSpecialistPractices] = useState(props.selectedSpecialistPractices);
  return (<>
    <Select label="Specialist Type" name="specialist_type" value={values.specialist_type} required={true}>
      <option value={""}> {"Specialist Type"}</option>
      {
        state.settings && state.settings.specialist_types.map(
          (x,y) => <option key={x}>{x}</option>
        )
      }
    </Select>
    <br />
    {values.specialist_type && values.specialist_type.length > 0 && (<>
      <label> Choose a specialist group or an individual specialist to be referred to. </label>
      <RadioGroup onChange={(el) => {
        setSelectedSpecialistPractice(null);
        setSelectedSpecialist(null);
        setSelectedSpecialistGroup(null);
        if (el.target.value == 'specialist_group') {
          setFieldValue('specialist_id', null);
          setFieldValue('specialist_practice_id', null);
          setSpecialistGroupDisabled(false);
          setSpecialistDisabled(true);
        } else {
          setFieldValue('specialist_group_id', null);
          setFieldValue('specialist_practice_id', null);
          setSpecialistGroupDisabled(true);
          setSpecialistDisabled(false);
        }
      }} required={true}>
          <FormControlLabel
            value={'specialist_group'}
            control={
              <Radio
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 25,
                  },
                }}
              />
            }
            label={'I want to refer patient to a specialist group'}
          />
          <FormControlLabel
            value={'specialist'}
            control={
              <Radio
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 25,
                  },
                }}
              />
            }
            label={'I want to refer patient to an individual specialist'}
          />
      </RadioGroup>
      {(!specialistGroupDisabled && specialistDisabled && !selectedSpecialistGroup &&(
        <>
          <SpecialistSearch
            setFieldValue={(specialist_group_id, specialistGroup) => {
              setFieldValue('specialist_group_id', specialist_group_id);
              setSelectedSpecialistGroup(specialistGroup);
            }}
            searchType="SpecialistGroup"
            patient={task.patient}
            value={values.specialist_group_id}
            specialistType={values.specialist_type}
          />
        </>
        ))
      }
      <div className='panel' style={{ 'border': '1px solid #efef'}}>
        <div className='panel-body'>
          {selectedSpecialistGroup && (<>
            <label>Selected Specialist Group: </label><b>{selectedSpecialistGroup.name }</b>
          </>) }
          {selectedSpecialist && (<>
            <label>Selected Specialist: </label> <b>{selectedSpecialist.name }</b>
          </>) }

          {selectedSpecialistPractice && (<>
            <label>Selected Specialist Practice: </label> <b>{selectedSpecialistPractice.name }</b>
          </>) }
          { (selectedSpecialistGroup || selectedSpecialist || selectedSpecialistPractice) && <>
            <div onClick={(el) => {
              setFieldValue('specialist_group_id', null);
              setFieldValue('specialist_id', null);
              setFieldValue('specialist_practice_id', null);
              setSelectedSpecialistGroup(null);
              setSelectedSpecialist(null);
              setSelectedSpecialistPractice(null);
            } } className='m-t-lg btn btn-default btn-red'>X CLEAR</div>
          </>}
        </div>
      </div>

      {specialistGroupDisabled && !specialistDisabled && !selectedSpecialist && <SpecialistSearch
        setFieldValue={(specialist_id, specialist) => {
          setFieldValue('specialist_id', specialist_id);
          setSelectedSpecialist(specialist);
        }}
        patient={task.patient}
        value={values.specialist_id}
        specialistType={values.specialist_type}
        searchType="Specialist"
      />}
    </>)}

    {(selectedSpecialistGroup || selectedSpecialist) && !selectedSpecialistPractice && <SpecialistSearch
      setFieldValue={(specialist_practice_id, specialistPractice) => {
        setFieldValue('specialist_practice_id', specialist_practice_id);
        setSelectedSpecialistPractice(specialistPractice);
      }}
      setSearchedSpecialistPractices={setSearchedSpecialistPractices}
      patient={task.patient}
      description='Select the specialist practice (OPTIONAL, leave blank if patient can be referred to ANY practice).'
      value={values.specialist_practice_id}
      specialistType={values.specialist_type}
      searchType="SpecialistPractice"
      specialistId={selectedSpecialist && selectedSpecialist.id}
      specialistGroupId={selectedSpecialistGroup && selectedSpecialistGroup.id}
    />}
  </>);
};

export default SpecialistSearchFormFields;
